//GLOBAL - components from npm
import React from "react";
import "./simpleBarChart.css";
import {
  ComposedChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Line,
} from "recharts";

//ASSETS - icons, images...
import { ReactComponent as EmptyState } from "../../../../build/images/emptystatemanagerhorizontal.svg";

import { ReactComponent as DashedLineIcon } from "../../../../build/images/nps-dashboard-icons/dashedLineIcon.svg";

// SERVICES

const initialData = [
  {
    name: "JAN",
    currentYearData: 2,
    lastYearData: 3,
    goal: 5,
  },
  {
    name: "FEV",
    currentYearData: 7,
    lastYearData: 2,
    goal: 5,
  },
  {
    name: "MAR",
    currentYearData: 3,
    lastYearData: 4,
    goal: 5,
  },
  {
    name: "ABR",
    currentYearData: 4,
    lastYearData: 5,
    goal: 5,
  },
  {
    name: "MAI",
    currentYearData: 2,
    lastYearData: 3,
    goal: 5,
  },
  {
    name: "JUN",
    currentYearData: 1,
    lastYearData: 2,
    goal: 5,
  },
  {
    name: "JUL",
    currentYearData: 0,
    lastYearData: 1,
    goal: 5,
  },
  {
    name: "AGO",
    currentYearData: 1,
    lastYearData: 2,
    goal: 5,
  },
  {
    name: "SET",
    currentYearData: 2,
    lastYearData: 1,
    goal: 5,
  },
  {
    name: "OUT",
    currentYearData: 2,
    lastYearData: 3,
    goal: 5,
  },
  {
    name: "NOV",
    currentYearData: 1,
    lastYearData: 2,
    goal: 5,
  },
  {
    name: "DEZ",
    currentYearData: 0,
    lastYearData: 1,
    goal: 5,
  },
];

export default function SimpleBarChart({
  dataStart = initialData,
  currentYear = "2024",
  lastYear = "2023",
  labelCurrentYear = "Promotor",
  labelLastYear = "Promotor",
  isGoalActive = false,
  isLimitDomainActive = false,
  limitDomain = [0, 10],
}) {
  //FUNCTIONS
  const CustomXAxisTick = ({ x, y, payload }) => {
    return (
      <text
        x={x}
        y={y}
        dy={8}
        fill="rgba(0, 0, 0, 0.38)"
        textAnchor="middle"
        fontSize={12}
        fontFamily="Inter"
      >
        {payload.value}
      </text>
    );
  };
  const CustomYAxisTick = ({ x, y, payload }) => {
    return (
      <g transform={`translate(${18},${y + 4})`}>
        <text
          x={0}
          y={0}
          textAnchor="start"
          fill="rgba(0, 0, 0, 0.38)"
          style={{ fontFamily: "Inter", fontSize: 12 }}
        >
          {payload.value}
        </text>
      </g>
    );
  };

  const CustomizedLabel = (props) => {
    return (
      <div>
        <div
          style={{
            display: "flex",
            gap: 16,
            justifyContent: "center",
            alignItems: "center",
            marginLeft: 58,
            paddingTop: 6,
          }}
        >
          {props && props.payload
            ? props.payload.map((item) => {
                switch (item.value) {
                  case `${labelCurrentYear} - ${currentYear}`:
                    return (
                      <div
                        style={{
                          display: "flex",
                          gap: 8,
                          alignItems: "center",
                          order: 0,
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                        >
                          <circle cx="6" cy="6" r="6" fill="#455CC7" />
                        </svg>
                        <div
                          style={{
                            fontSize: 12,
                            fontFamily: "Inter",
                            fontStyle: "normal",
                            fontWeight: 500,
                            lineHeight: "112.5%",
                            letterSpacing: 0.25,
                            color: "#757575",
                          }}
                        >
                          {item.value}
                        </div>
                      </div>
                    );
                  case `${labelLastYear} - ${lastYear}`:
                    return (
                      <div
                        style={{
                          display: "flex",
                          gap: 8,
                          alignItems: "center",
                          order: 2,
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                        >
                          <circle cx="6" cy="6" r="6" fill="#1E88E5" />
                        </svg>
                        <div
                          style={{
                            fontSize: 12,
                            fontFamily: "Inter",
                            fontStyle: "normal",
                            fontWeight: 500,
                            lineHeight: "112.5%",
                            letterSpacing: 0.25,
                            color: "#757575",
                          }}
                        >
                          {item.value}
                        </div>
                      </div>
                    );
                  case "Meta":
                    return (
                      <div
                        style={{
                          display: "flex",
                          gap: 8,
                          alignItems: "center",
                          order: 1,
                        }}
                      >
                        <DashedLineIcon />
                        <div
                          style={{
                            fontSize: 12,
                            fontFamily: "Inter",
                            fontStyle: "normal",
                            fontWeight: 500,
                            lineHeight: "112.5%",
                            letterSpacing: 0.25,
                            color: "#757575",
                          }}
                        >
                          {item.value}
                        </div>
                      </div>
                    );
                  default:
                    return null;
                }
              })
            : null}
        </div>
      </div>
    );
  };

  return (
    <div className="simpleBarChartComparisons">
      {dataStart && dataStart.length ? (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ResponsiveContainer width="100%" height="100%">
            <ComposedChart
              // width={500}
              // height={300}
              data={dataStart}
              margin={{
                top: 20,
                right: 30,
                left: 0,
                bottom: 5,
              }}
            >
              <CartesianGrid
                vertical={false}
                strokeDasharray="none"
                strokeWidth="1"
                stroke="rgba(0, 0, 0, 0.05)"
              />
              <XAxis dataKey="name" tick={<CustomXAxisTick />} />
              {isLimitDomainActive ? (
                <YAxis
                  axisLine={false}
                  tick={<CustomYAxisTick />}
                  domain={limitDomain}
                  // tickFormatter={(value) => {
                  //   const isValidValue = value.toString().split(".").length <= 1;
                  //   if (isValidValue) {
                  //     return value;
                  //   } else {
                  //     return "";
                  //   }
                  // }}
                />
              ) : (
                <YAxis
                  axisLine={false}
                  tick={<CustomYAxisTick />}
                  // tickFormatter={(value) => {
                  //   const isValidValue = value.toString().split(".").length <= 1;
                  //   if (isValidValue) {
                  //     return value;
                  //   } else {
                  //     return "";
                  //   }
                  // }}
                />
              )}
              <Tooltip />
              <Legend
                layout="horizontal"
                verticalAlign="bottom"
                align="center"
                fontSize={12}
                content={CustomizedLabel}
              />
              <Bar
                dataKey="currentYearData"
                name={`${labelCurrentYear} - ${currentYear}`}
                fill="#455CC7"
                barSize={8}
                radius={[4, 4, 0, 0]}
              />
              <Bar
                dataKey="lastYearData"
                name={`${labelLastYear} - ${lastYear}`}
                fill="#1E88E5"
                barSize={8}
                radius={[4, 4, 0, 0]}
              />
              {isGoalActive ? (
                <Line
                  strokeWidth={2}
                  name="Meta"
                  dot={false}
                  activeDot={false}
                  strokeDasharray="3 3"
                  dataKey="goal"
                  stroke="#FFB300"
                />
              ) : null}
            </ComposedChart>
          </ResponsiveContainer>
        </div>
      ) : (
        <div className="card-table__area-empty">
          <EmptyState />
        </div>
      )}
    </div>
  );
}
